import React from "react"

import { Ten, Arrow, Percentages, One, Two, Three } from "./icon"

export const ITEMS = {
  THREE_STEPS_ITEMS: [
    { title: "Оформите", description: "Онлайн-заявка за несколько минут", Icon: One },
    {
      title: "Получите",
      description: (
        <>
          В отделении банка <br /> или закажите доставку
        </>
      ),
      Icon: Two,
    },
    {
      title: "Активируйте",
      description: (
        <>
          Совершите первую покупку <br /> в партнерском магазине
        </>
      ),
      Icon: Three,
    },
  ],
  DEFAULT_ITEMS: [
    { title: "+5% к ставке вкладов Совкомбанка", Icon: Arrow },
    { title: "10% кэшбэк у партнеров", Icon: Percentages },
    { title: <>10 месяцев рассрочки* у&nbsp;партнеров</>, Icon: Ten },
  ],
}
